module.exports = new __parcel__URL__("step-incidents.bbada1c7.svg").toString();